import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=258418a7&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=258418a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258418a7",
  null
  
)

export default component.exports